export default () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6017 5.31257C11.6017 6.86602 10.3426 8.12515 8.78914 8.12515C7.23569 8.12515 5.97656 6.86602 5.97656 5.31257C5.97656 3.75913 7.23569 2.5 8.78914 2.5C10.3426 2.5 11.6017 3.75913 11.6017 5.31257Z"
      fill="currentColor"
    />
    <path
      d="M3.89235 14.5H13.6871C14.0893 14.5 14.4149 14.1744 14.4149 13.7722C14.4149 11.2753 12.39 9.24976 9.89242 9.24976H7.68651C5.18963 9.24976 3.16406 11.2746 3.16406 13.7722C3.16406 14.1744 3.48967 14.5 3.89184 14.5H3.89235Z"
      fill="currentColor"
    />
  </svg>
);
